interface ProductIdWithSizeIds {
  productId: number;
  sizeIds: number[];
}

export type ProductIdsWithSizeIds = ProductIdWithSizeIds[];

interface AbstractItemType {
  productId?: number;
  sizeId?: number;
  product?: {
    variants?: {
      id: number;
    }[];
  };
}

export const reduceVariantIdsToProductIds = (
  items: AbstractItemType[],
): ProductIdsWithSizeIds => {
  return items.reduce((products: ProductIdsWithSizeIds, item) => {
    if (item.productId === undefined) {
      return products;
    }
    const productId = +item.productId;
    const sizeId = item.sizeId;

    const sizeList = [];

    if (sizeId !== undefined) {
      sizeList.push(+sizeId);
    } else if (item.product?.variants) {
      sizeList.push(...item.product.variants.map(variant => +variant.id));
    }

    const reducedProduct = products.find(
      product => product.productId === productId,
    );

    if (!reducedProduct) {
      products.push({
        productId,
        sizeIds: sizeList,
      });
    } else if (
      sizeId !== undefined &&
      reducedProduct?.sizeIds.indexOf(sizeId) === -1
    ) {
      reducedProduct.sizeIds.push(sizeId);
    }

    return products;
  }, []);
};
